import React, { Component } from 'react';
import Validator from 'validatorjs';
import { Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';
import CartaPorteClaveUnidadPesoSuggestions from './suggestions/CartaPorteClaveUnidadPesoSuggestions';

class CartaPorteMercanciaResumenForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    const { data = {} } = props;

    this.state = {
      data: { ...data },
      isValid: false,
      validator: new Validator({}, this.rules({})),
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.data !== state.data) {
      return {
        data: props.data,
      };
    }

    // Return null to indicate no change to state.
    return null;
  }

  rules(data) {
    return {
      PesoBrutoTotal: ['required', 'min:0.001'],
      UnidadPeso: ['required', 'string'],
      PesoNetoTotal: ['min:0.001'],
      NumTotalMercancias: ['required', 'integer'],
      CargoPorTasacion: ['min:0.000000'],
      LogisticaInversaRecoleccionDevolucion: ['string', 'in:Sí'],
    };
  }

  handleOnChange = (value) => {
    const data = {
      ...this.state.data,
      ...value,
    };

    this.notifyFormDataChange(data);
  };

  notifyFormDataChange = (values) => {
    const data = {
      ...this.state.data,
      ...values,
    };

    const validator = this.validate(data);

    this.setState({
      data,
      isValid: validator.passes(),
    });

    this.props.onChange(data);
  };

  validate(data) {
    const validator = new Validator(data, this.rules(data));

    validator.check();

    this.setState({
      validator,
    });

    return validator;
  }

  handleOnSuggestionSelect = (name) => (item) => {
    const value = item ? item.clave : '';

    let values = {
      [name]: value,
    };

    this.handleOnChange(values);
  };

  render() {
    const { data = {} } = this.state;
    const rules = this.rules();

    return (
      <>
        <Row>
          <Col>
            <strong>Resumen de Mercancias</strong>
          </Col>
        </Row>
        <Row>
          <Col
            sm
            md={4}
          >
            <FormControl
              type="number"
              label="Peso Bruto Total"
              name="PesoBrutoTotal"
              placeholder=""
              help=""
              rules={rules.PesoBrutoTotal}
              value={data.PesoBrutoTotal}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <CartaPorteClaveUnidadPesoSuggestions
              label="Unidad Peso"
              name="UnidadPeso"
              value={data.UnidadPeso}
              rules={rules.UnidadPeso}
              onSelect={this.handleOnSuggestionSelect('UnidadPeso')}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="number"
              label="Peso Neto Total"
              name="PesoNetoTotal"
              placeholder=""
              help=""
              rules={rules.PesoNetoTotal}
              value={data.PesoNetoTotal}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="number"
              label="Número Total Mercancias"
              name="NumTotalMercancias"
              placeholder=""
              help=""
              rules={rules.NumTotalMercancias}
              value={data.NumTotalMercancias}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="number"
              label="Cargo por Tasación"
              name="CargoPorTasacion"
              placeholder=""
              help=""
              rules={rules.CargoPorTasacion}
              value={data.CargoPorTasacion}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="select"
              label="Logistica Inversa Recoleccion Devolucion"
              name="LogisticaInversaRecoleccionDevolucion"
              placeholder=""
              help=""
              minLength="2"
              maxLength="2"
              rules={rules.LogisticaInversaRecoleccionDevolucion}
              value={data.LogisticaInversaRecoleccionDevolucion}
              options={Logistica}
              onChange={this.handleOnChange}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <p className="text-muted">Los totales serán calculados automáticamente</p>
          </Col>
        </Row>
      </>
    );
  }
}

const Logistica = [
  {
    label: 'Selecciona',
    value: '',
  },
  {
    label: 'Sí',
    value: 'Sí',
  },
];

export default CartaPorteMercanciaResumenForm;
